import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'

// TODO: By default, we use fixed +-5 months. Define elsewhere?
const MONTHS_SPAN = 4
const getMonths = () => {
  const run = moment().subtract(MONTHS_SPAN, 'months')
  const end = moment().add(MONTHS_SPAN, 'months')
  const dates = []
  while(run.isBefore(end)) {
    dates.push({ month: run.format('MM'), year: run.year() })
    run.add(1, 'month')
  }
  return dates
}

class MonthSelector extends React.Component {
  constructor(props) {
    super(props)
    const dates = getMonths()
    this.state = {
      date: dates[MONTHS_SPAN],
      dates
    }
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(e, i) {
    const { dates } = this.state
    const { onSelect } = this.props
    const date = dates[i]
    this.setState({ date })
    onSelect(date)
  }

  render() {
    const { date, dates } = this.state

    return (
      <SelectField
        floatingLabelText="Período"
        value={date}
        onChange={this.handleChange} style={{ width: 180 }}>
        {dates.map((d, i) => (
          <MenuItem key={i} value={dates[i]} primaryText={`${d.month}/${d.year}`} />
        ))}
      </SelectField>
    )
  }
}
MonthSelector.propTypes = {
  onSelect: PropTypes.func.isRequired
}

export default MonthSelector



// WEBPACK FOOTER //
// ./src/components/MonthSelector.js